import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { MembershipDTOBase } from "./MembershipDTOBase";
import type { MembershipTypeRef } from "./MembershipTypeRef";
import type { MembershipTypeStaff } from "./MembershipTypeStaff";
import type { PersonStaff } from "./PersonStaff";
import type { PurchasableState } from "./PurchasableState";
import type { TrackedBase } from "./TrackedBase";

export class MembershipStaff implements MembershipDTOBase, TrackedBase {
  constructor(public readonly assignId: number, public readonly personId: PersonStaff | null, public readonly membershipTypeId: MembershipTypeStaff | null, public readonly purchaseDate: Date | null, public readonly startDate: Date | null, public readonly expirationDate: Date | null, public readonly price: number, public readonly purchasableState: PurchasableState, public readonly voidCloseId: number | null, public readonly temp: boolean, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly guestPrivileges: boolean, public readonly membershipTypeIdTargetIds: MembershipTypeRef, public readonly membershipTypeName: string | null, public readonly programName: string | null) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
    this.membershipTypeIdLoaded = this.membershipTypeId != null;
    this.membershipTypeIdCached = this.membershipTypeId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  private membershipTypeIdLoaded: boolean;
  private membershipTypeIdCached: MembershipTypeStaff | null;
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.membershipService().getMembershipStaffPersonId(this.assignId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
  async membershipTypeIdLazy(): Promise<MembershipTypeStaff> {
    if (!this.membershipTypeIdLoaded) {
      this.membershipTypeIdCached = await this.cbiServiceContext!.membershipService().getMembershipTypeStaff(this.membershipTypeIdTargetIds.membershipTypeId);
      this.membershipTypeIdLoaded = true;
    }
    return this.membershipTypeIdCached!;
  }
}
